import { VFC, useMemo } from 'react'
import { NoticeChatwork, NoticeEmail, NoticeSlack } from 'src/assets/svgs'
import styled from 'styled-components'

type Props = {
  onChange: (next: boolean) => unknown
  currentValue: boolean
  type: 'chatwork' | 'slack' | 'email'
}

export const NoticeItem: VFC<Props> = ({ onChange, type, currentValue }) => {
  const [label, Icon] = useMemo(() => {
    if (type === 'email') {
      return ['メールに送信', NoticeEmail]
    }

    if (type === 'chatwork') {
      return ['Chatworkに通知', NoticeChatwork]
    }

    if (type === 'slack') {
      return ['Slackに通知', NoticeSlack]
    }

    return ['', NoticeSlack]
  }, [type])

  return (
    <Wrapper>
      <Icon width="24" />
      <Text>{label}</Text>
      <OnOffWrapper>
        <OnOffItem
          direction="left"
          active={currentValue === false}
          onClick={() => onChange(false)}
        >
          <OnOffText active={currentValue === false}>しない</OnOffText>
        </OnOffItem>
        <OnOffItem
          direction="right"
          active={currentValue === true}
          onClick={() => onChange(true)}
        >
          <OnOffText active={currentValue === true}>する</OnOffText>
        </OnOffItem>
      </OnOffWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.label`
  display: flex;
  padding: 4px 8px;
  align-items: center;
`

const Text = styled.p`
  padding: 0 16px;
  font-size: 14px;
  line-height: 1.5;
  flex: 1;
  color: #606060;
`

const OnOffWrapper = styled.div`
  width: 40%;
  display: flex;
`

const OnOffItem = styled.div<{
  direction: 'left' | 'right'
  active: boolean
}>`
  cursor: pointer;
  width: 50%;
  ${({ active }) => (active ? 'background: #FEF6EF;' : '')}

  ${({ direction }) =>
    direction === 'left'
      ? 'border-radius: 5px 0 0 5px;'
      : 'border-radius: 0 5px 5px 0;'}

  ${({ active }) =>
    active ? 'border: solid 1px #FF6C01;' : 'border: solid 1px #CDCDCD;'}
`

const OnOffText = styled.p<{
  active: boolean
}>`
  text-align: center;
  font-size: 14px;
  padding: 12px 16px;

  ${({ active }) => (active ? 'color: #FF6C01;' : 'color: #606060;')}
`
